import React, { useState } from 'react'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Axios from 'axios';

const SyncTab = () => {

  const [cid,setCid] = useState('');
  const [status,setstatus] = useState('');

  const handleChange = (e) => {
      setCid(e.target.value);
  }

  const handleSubmit = () => {
    console.log("submit click")
    Axios.get(`https://tools.vuclip.com/api/ottSyncData?type=0&token=vuclip2014&cid=${cid}`)
    .then((response)=>{
      console.log(response.data.result)
      setstatus(response.data.result)
    })
    .catch((err)=>{
      console.log(err)
      setstatus("Facing error Contact CMS team")
    })
  }




  return (
    <Paper>
      <Stack direction='row' spacing={10}>

        <Box sx={{ margin: '30px 30px 30px 50px' }}>
        <TextField
         id="outlined-cid"
         label="CID"
         onChange={handleChange}
         name="cidInputValue"
         margin="normal"
         variant="outlined"
         fullWidth
         value={cid}
         />
        </Box>

        <Box sx={{ paddingTop: '50px' }}>
        <Button variant="contained"  color="primary" type="submit" onClick={handleSubmit}>
          Check
        </Button>
        </Box>

        <Box sx={{ padding: '50px 0px 0px 80px' }}>
          {status ? <b>{status}</b>: <b>Status will show here</b>}
        </Box>
        
  
      </Stack>
       
    </Paper>
    
  )
}

export default SyncTab